import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, font, spacers, mediaQuery } = baseVariables;

export const StyledSearchFormMobile = styled.div<{ isSearchResultPage: boolean; isSticky: boolean }>`
  padding: ${({ isSticky, isSearchResultPage }) =>
    isSticky ? `${toRem(8)} ${toRem(16)}` : isSearchResultPage ? `${toRem(8)} ${toRem(0)}` : `0`};
  @media ${mediaQuery.md} {
    padding: ${({ isSticky, isSearchResultPage }) => (isSticky || isSearchResultPage ? `${toRem(8)} 0` : `0`)};
  }

  .w-100 {
    width: 100%;
  }

  .m-input-field {
    .input-search-box {
      border-radius: ${toRem(32)} !important;
      background-color: ${color.base20};
      height: ${toRem(56)};
    }
  }

  .m-dropdown-header {
    padding-bottom: ${toRem(16)};
  }

  .search-form-mobile-modal {
    .dropdown-to-modal {
      height: 80vh;
      padding: ${toRem(24)} ${toRem(16)} 0 ${toRem(16)};
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      .m-dropdown-content {
        display: flex !important;
        flex-direction: column !important;
        height: 100% !important;
        min-height: unset !important;
        max-height: 100% !important;
        z-index: 99;
      }
    }

    .m-dropdown-header {
      flex-shrink: 0;
    }

    .m-dropdown-children {
      flex: 1 !important;
      overflow: hidden !important;
      min-height: 0 !important;
      display: flex !important;
      flex-direction: column !important;
      height: 0 !important;
    }
    .modal-destination-field {
      padding: 0 0;
      .m-input-text-field {
        position: relative;
        input {
          font-size: ${toRem(16)} !important;
          line-height: ${toRem(20)} !important;
          height: ${toRem(56)} !important;
          color: ${color.base10} !important;
          &::placeholder {
            color: ${color.neutral30} !important;
          }
          &:focus {
            border-color: ${color.base10} !important;
            outline: none;
          }
        }
        label {
          font-size: ${toRem(14)};
          font-weight: ${font.fontWeightMedium};
          line-height: ${toRem(16)};
          text-transform: none;
        }
        .icon {
          left: initial;
          position: absolute;
          right: ${toRem(8)};
          top: ${toRem(20)};
        }
      }
    }

    .expanded-form-content {
      padding: ${spacers.spacer};
    }

    .modal-content-wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
    }

    .modal-body {
      flex: 1;
      overflow-y: auto;
      min-height: 0;
    }

    .modal-common-footer {
      flex-shrink: 0;
      padding: ${toRem(16)} 0;
      display: flex;
      justify-content: flex-end;
      .find-btn {
        width: 100%;
        height: ${toRem(48)};
      }
    }
  }
`;
